import React from 'react';
import { IBusinessLocation } from 'models';
import { Colors, Text } from 'library';
import { Grid, styled } from '@mui/material';
import EducationTypesSection from './EducationTypesSection';

export default function BusinessLocationDetailsSection({
    businessLocation,
    updateLocation,
}: {
    businessLocation: IBusinessLocation;
    updateLocation: (loc: IBusinessLocation) => void;
}) {
    return (
        <Container container item direction="column">
            <Text variant="h1" textStyle={{ marginBottom: 10 }}>
                Center Details
            </Text>
            <EducationTypesSection
                locationId={businessLocation.id}
                educationTypes={businessLocation.education_type_names}
                updateLocation={updateLocation}
            />
        </Container>
    );
}

const Container = styled(Grid)({
    backgroundColor: Colors.white,
    borderRadius: 18,
    padding: 20,
});
